import { PartialNullable } from "../../Extensions";
import { IPromisePublic, PromiseHelper } from "../../Helpers/PromiseHelper";
import { JNative, JNativeStatic } from "../../JNative";
import { Property } from "../../RadObject";
import { Dialog, DialogPropertyValues, IDialog } from "./Dialog";
import { NAMESPACE } from "./_Namespace";

interface AjaxResponseMessageQueueItem { properties: { responseMessages: string[] }, promise: IPromisePublic<any> }

export type AjaxResponseMessageDialogPropertyValues =
    DialogPropertyValues
    & {
    };

export type AjaxResponseMessageDialogProperties = {
    [name in keyof AjaxResponseMessageDialogPropertyValues]: Property<AjaxResponseMessageDialogPropertyValues[name]>
};

export interface IAjaxResponseMessageDialog extends IDialog, AjaxResponseMessageDialogProperties
{
}

export class AjaxResponseMessageDialog extends Dialog implements IAjaxResponseMessageDialog
{
    // #region Static

    public static override classNamespace = NAMESPACE + "AjaxResponseMessageDialog";
    public static override className = "AjaxResponseMessageDialog";

    // #region Global Variables

    private static messageDialog?: AjaxResponseMessageDialog;
    private static messageQueue: AjaxResponseMessageQueueItem[] = [];

    // #endregion

    // #region Public Methods

    public static displayMessages(responseMessages: string[])
    {
        const
            promise = PromiseHelper.createPromisePublic();

        this.messageQueue.push({
            properties: {
                responseMessages: responseMessages
            },
            promise: promise
        });

        this.checkQueue();

        return promise;
    }

    // #endregion

    // #region Private Methods

    private static checkQueue()
    {
        // TODO: Duplication

        if (!this.messageDialog)
            this.messageDialog = new AjaxResponseMessageDialog();

        if (!this.messageDialog.opened && this.messageQueue.length)
        {
            let
                item: AjaxResponseMessageQueueItem | undefined;

            while (item == undefined && this.messageQueue.length)
                item = this.messageQueue.shift();

            if (item)
            {
                this.messageDialog
                    .openAsync(item.properties.responseMessages)
                    .then((...args) => { item!.promise.resolve.apply(item!.promise, args); })
                    .catch(error => { item!.promise.reject(error); })
                    .finally(() => { this.checkQueue(); });
            }
        }
    }

    // #endregion

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<AjaxResponseMessageDialogPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                title: "Action Completed Successfully",
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Global Variables

    protected $$p?: JNative<HTMLElement>;
    protected $$list?: JNative<HTMLElement>;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<AjaxResponseMessageDialogPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _createElement()
    {
        const
            $$element = super._createElement(),
            $$containerElement = this._containerElementRef.current;

        this.$$p =
            JNativeStatic.create$$("p", null, "Please note:")
                .appendTo($$containerElement);

        this.$$list =
            JNativeStatic.create$$("ul")
                .appendTo($$containerElement);

        return $$element;
    }

    public override openAsync(responseMessages: string[])
    {
        this.$$list?.empty();

        responseMessages.forEach(item =>
        {
            this.$$list?.append(JNativeStatic.create$$("li").text(item));
        });

        return super.openAsync(responseMessages);
    }

    // #endregion

    // #endregion
}
